import { useState } from "react";
import { api, errText } from "../../lib/api";

export const ContentJobStatus = ({ job, model, onChanged, testid, unit }) => {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  if (!job) return null;
  const running = ["queued", "running"].includes(job.status);
  const failed = !!job.failed;
  const canRetry = (job.failed_city_ids?.length || job.failed_pairs?.length) && !running;
  const act = async action => {
    setBusy(true); setError("");
    try { await api.post(`/admin/content-jobs/${job.id}/${action}`, { model: model || null }); await onChanged(); }
    catch (e) { setError(errText(e)); }
    finally { setBusy(false); }
  };
  return <div className="space-y-2 mb-4 text-xs break-words" data-testid={testid}>
    <p className={failed ? "text-danger" : "text-muted"} data-testid={`${testid}-summary`}>
      Last run: {job.status}{job.status === "done" && failed ? " with errors" : ""} · {job.done || 0}/{job.total ?? "?"} {unit}
      {failed ? ` · ${job.failed} failed` : ""}{job.model ? ` · ${job.model}` : ""}
    </p>
    {job.last && <p data-testid={`${testid}-last`}>{job.last}</p>}
    <div className="flex flex-wrap gap-2">
      {running && <button className="btn-ghost text-xs px-3" type="button" data-testid={`${testid}-cancel`} disabled={busy || job.cancel_requested} onClick={() => act("cancel")}>{job.cancel_requested ? "Stopping after current page…" : "Stop job"}</button>}
      {!!canRetry && <button className="btn-ghost text-xs px-3" type="button" data-testid={`${testid}-retry`} disabled={busy} onClick={() => act("retry")}>Retry failed only</button>}
    </div>
    {error && <p role="alert" className="text-danger" data-testid={`${testid}-error`}>{error}</p>}
  </div>;
};